import { Box, Typography, Checkbox } from '@mui/material';
import { CustomSingleSelect } from './common/inputFields/customSingleSelect';
import { CustomMultiSelect } from './common/inputFields/customMultiSelect';
import { CustomTextInput } from './common/inputFields/customTextInput';
import { CustomAutoComplete } from './common/inputFields/customAutoComplete';
import { CustomMulitLineTextField } from './common/inputFields/customMultiLineTextFIeld';

export const renderSubTitle = (title: string) => (
  <Box sx={{ borderBottom: '1px solid #55575C', paddingBottom: 1, marginTop: 1 }}>
    <Typography
      sx={{
        fontSize: '16px !important',
        fontFamily: 'Helvetica Neue, sans-serif !important',
        fontWeight: '600 !important',
        color: '#55575C !important'
      }}
    >
      {title}
    </Typography>
  </Box>
);

export function renderAutocomplete<T extends { id: number }>(
  label: string,
  selectedValue: T | string | null,
  options: T[],
  labelKey: keyof T,
  handleChange: (value: T | string | null) => void
) {
  return (
    <CustomAutoComplete<T>
      label={label}
      selectedValue={selectedValue ?? null}
      options={options}
      labelKey={labelKey}
      heightOverride={null}
      handleSelectChange={(_e, newValue) => handleChange(newValue)}
    />
  );
}

export function renderCheckbox(
  label: string,
  value: boolean,
  handleChange: (value: boolean) => void
) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0 }}>
      <Checkbox
        disableRipple
        checked={Boolean(value)}
        onChange={(e) => handleChange(e.target.checked)}
        sx={{ color: '#1B7A63 !important' }}
      />
      <Typography
        sx={{
          fontSize: '14px !important',
          fontFamily: 'Helvetica Neue, sans-serif !important',
          color: '#55575C !important'
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export function renderSelect(
  label: string,
  selected: any,
  options: any[],
  labelKey: string,
  handleChange: (value: any) => void
) {
  return (
    <CustomSingleSelect
      value={selected?.id || ''}
      onChange={(e) => {
        const selectedItem = options.find((opt) => opt.id === e.target.value);
        handleChange(selectedItem);
      }}
      options={options}
      placeholder={`Select a ${label}`}
      labelKey={labelKey}
    />
  );
}

export function renderMultiSelect(
  label: string,
  selectedItems: any[],
  options: any[],
  labelKey: string,
  handleChange: (value: any[]) => void
) {
  return (
    <CustomMultiSelect
      value={selectedItems.map((item) => item.id)}
      onChange={(e) => {
        const selected = options.filter((opt) => e.target.value.includes(opt.id));
        handleChange(selected);
      }}
      options={options}
      labelKey={labelKey}
      placeholder={`Select ${label}`}
      fullWidth={true}
    />
  );
}


export function renderTextInput<T>(
  label: string,
  field: keyof T,
  object: Partial<T>,
  handleChange: (value: any) => void,
  type: 'text' | 'number' | 'date',
  _delay?: number,
  formatNumber?: boolean,
  multiline?: boolean
) {
  return (
    <CustomTextInput
      label={label}
      type={type}
      value={object[field] as any ?? ''}
      onChange={handleChange}
      heightOverride={''}
      redOutline={false}
      formatNumber={formatNumber}
      multiline={multiline}
    />
  );
}

export function renderMultiLineTextInput(
  label: string,
  value: string,
  handleChange: (val: string) => void,
  delay?: number
) {
  return (
    <CustomMulitLineTextField
      label={label}
      value={value ?? ''}
      onChange={(val) => handleChange(String(val))}
      delay={delay}
    />
  );
}
